import { useEffect, useState } from "react";
import axios from "axios";

const clashDisplay = { fontFamily: "'Clash Display', sans-serif" };
const manrope = { fontFamily: "'Manrope', sans-serif" };

export default function AdminDashboard() {
  const [products, setProducts] = useState([]);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [longDescription, setLongDescription] = useState("");
  const [category, setCategory] = useState("");
  const [image, setImage] = useState("");
  const [cta, setCta] = useState("");

  const token = localStorage.getItem("adminToken"); 
  const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

  // Fetch products from backend
  const fetchProducts = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/products`);
      setProducts(res.data);
    } catch (err) {
      console.error("Error fetching products:", err);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const handleAddProduct = async () => {
    try {
      const res = await axios.post(
        `${API_URL}/api/products`,
        { title, description, longDescription, category, image, cta },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setProducts([...products, res.data]);
      setTitle(""); setDescription(""); setLongDescription(""); setCategory(""); setImage(""); setCta("");
    } catch (err) {
      console.log(err.response?.data || err.message);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${API_URL}/api/products/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setProducts(products.filter((p) => p._id !== id));
    } catch (err) {
      console.log(err.response?.data || err.message);
    }
  };

  return (
    <div className="w-full min-h-screen bg-black py-12 px-6">
      <h1 className="text-3xl text-white font-bold mb-10" style={clashDisplay}>
        Admin Dashboard
      </h1>

      {/* Add Product Form */}
      <div className="bg-white rounded-xl shadow-md p-6 mb-12 max-w-4xl mx-auto">
        <h2 className="text-xl font-bold mb-4" style={clashDisplay}>
          Add New Product
        </h2>
        <div className="flex flex-col gap-4">
          <input
            placeholder="Title"
            className="p-2 border rounded"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <input
            placeholder="Description"
            className="p-2 border rounded"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
          <input
            placeholder="Long Description"
            className="p-2 border rounded"
            value={longDescription}
            onChange={(e) => setLongDescription(e.target.value)}
          />
          <input
            placeholder="Category"
            className="p-2 border rounded"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          />
          <input
            placeholder="Image URL"
            className="p-2 border rounded"
            value={image}
            onChange={(e) => setImage(e.target.value)}
          />
          <input
            placeholder="CTA"
            className="p-2 border rounded"
            value={cta}
            onChange={(e) => setCta(e.target.value)}
          />
          <button
            className="bg-[#158DC1] text-white px-4 py-2 rounded-md hover:bg-[#0f6b94] transition-colors"
            onClick={handleAddProduct}
          >
            Add Product
          </button>
        </div>
      </div>

      {/* Products List */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {products.map((p) => (
          <div key={p._id} className="bg-white rounded-xl shadow-md p-6 flex flex-col items-center text-center">
            {p.image && <img src={p.image} alt={p.title} className="w-32 h-32 object-cover mb-4 rounded" />}
            <h3 className="text-lg font-bold mb-2" style={clashDisplay}>{p.title}</h3>
            <p className="text-sm text-gray-700 mb-2" style={manrope}>{p.description}</p>
            {p.longDescription && <p className="text-xs text-gray-500 mb-2">{p.longDescription}</p>}
            <p className="text-sm text-gray-500 mb-4">{p.category}</p>
            <button
              className="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700 transition-colors"
              onClick={() => handleDelete(p._id)}
            >
              Delete
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
